export const LANGUAGE_STORAGE_KEY = 'persona.language';
export const SUPPORTED_LANGUAGES = ['en', 'fr'];
export const DEFAULT_LANGUAGE = 'en';

export function isSupportedLanguage(lang) {
  return SUPPORTED_LANGUAGES.includes(lang);
}

export function getStoredLanguage() {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    return isSupportedLanguage(stored) ? stored : null;
  } catch (e) {
    return null;
  }
}

export function setStoredLanguage(lang) {
  if (!isSupportedLanguage(lang)) {
    return;
  }
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch (e) {
  }
}

export function applyDocumentLanguage(lang) {
  if (typeof document !== 'undefined' && isSupportedLanguage(lang)) {
    document.documentElement.lang = lang;
  }
}
